//These are the things we want to use to define the core colors and measurments we use in the theme.
//They should be used in the theme definitions, but not on components. It's more behind the scenes.

const BASE_FONT_SIZE = 14;

export const colors: Record<string, string> = {
  FOUNDATION_100: '#d1f3ff', //tundra 100
  FOUNDATION_200: '#a9d5e5', //tundra 200
  FOUNDATION_300: '#8cb4c2', //tundra 300
  FOUNDATION_400: '#6b8d99', //tundra 400
  FOUNDATION_500: '#283b42', //tundra 500
  ACCENT_50: '#fedfd7', //sahara 50
  ACCENT_100: '#e5927d', //sahara 100
  ACCENT_200: '#c37c6a', //sahara 200
  ACCENT_300: '#84564a', //sahara 300
  CONTRAST_LIGHTEST: '#ffffff',
  CONTRAST_DARKEST: '#000000',
  TEXT_HIGH_EMPHASIS: '#203D48',
  TEXT_MEDIUM_EMPHASIS: '#717F96',
  TEXT_LOW_EMPHASIS: '#B0CCD6',
  SUCCESS_300: '#CCFFDA',
  SUCCESS_500: '#42A45C',
  WARNING_300: '#FFE9CC',
  WARNING_500: '#F5A73F',
  ALERT_300: '#FFCCCC',
  ALERT_500: '#E50000',
  PROGRESS_300: '#E0E8FF',
  PROGRESS_500: '#4169E1',
  STRUCTURAL_50: '#FCFEFF',
  STRUCTURAL_100: '#F7FDFF',
  STRUCTURAL_200: '#F0FBFF',
  STRUCTURAL_300: '#F2F8FA',
  STRUCTURAL_400: 'F6FDFF',
  CHIPS_GREY_50: '#F0F2F4',
  CHIPS_GREY_500: '#45556E',
  CHIPS_BROWN_50: '#FEEEEA',
  CHIPS_GREEN_50: '#E0FCF0',
  CHIPS_GREEN_500: '#26835B',
  CHIPS_YELLOW_50: '#FFF7D8',
  CHIPS_YELLOW_500: '#E1B129',
  CHIPS_RED_50: '#FFEDEC',
  CHIPS_RED_500: '#C83729',
  CHIPS_BLUE_50: '#EAF2FF',
  CHIPS_BLUE_500: '#186AE1',
  CHIPS_TEAL_50: '#EDF4F7',
  CHIPS_TEAL_500: '#45626E',
  CHIPS_PLUM_50: '#F3EAF2',
  CHIPS_PLUM_500: '#875882',
  OPACITY_SECONDARY_10: '#D1F3FF1A',
  OPACITY_PRIMARY_15: '#FEDFD7'
};

export const pxToRem = (px: number, baseFontSize: number = BASE_FONT_SIZE) => {
  return `${px / baseFontSize}rem`;
};

export const spacing = (...args: string[]) => {
  /**This method allows to give margin/padding spacing in rem to all the 4 sides.
   * Usage egs: spacing('4','9','10','4'), spacing('20%','10','10%','40'), spacing('5') etc
   */
  let pixels: string = '';
  args.forEach((arg) => {
    if (isNaN(Number(arg))) pixels = pixels.concat(`${arg} `);
    else pixels = pixels.concat(`${pxToRem(Number(arg))} `);
  });
  return pixels;
};
